import Column from "@amzn/meridian/column";
import Input from "@amzn/meridian/input";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import React from "react";
import { useFilterSheets } from "./hooks";
import { useAppDispatch } from "../../app/store/hooks";
import { IFilterInputRange } from "./definitions";

export const FilterInputRange: React.FC<IFilterInputRange> = ({ inputRangeInfo }) => {
    const dispatch = useAppDispatch();
    const { filterMap, handleFilterMapUpdate } = useFilterSheets();

    return (
        <Column spacing={"200"}>
            <Text type={"h100"}>{inputRangeInfo.label}</Text>
            <Row spacing={"600"}>
                <Input
                    value={filterMap.get(inputRangeInfo.keyValue)?.value[0] || ""}
                    onChange={selectedValue =>
                        dispatch(
                            handleFilterMapUpdate({
                                type: "UPDATE",
                                filterKey: inputRangeInfo.keyValue,
                                filterLabel: inputRangeInfo.startLabel,
                                value: [
                                    selectedValue,
                                    filterMap.get(inputRangeInfo.keyValue)?.value[1] || "",
                                ],
                            })
                        )
                    }
                    type="number"
                    placeholder="0.00"
                    label={inputRangeInfo.startLabel}
                    size="medium"
                    prefix={inputRangeInfo.startPrefix}
                />
                <Input
                    value={filterMap.get(inputRangeInfo.keyValue)?.value[1] || ""}
                    onChange={selectedValue =>
                        dispatch(
                            handleFilterMapUpdate({
                                type: "UPDATE",
                                filterKey: inputRangeInfo.keyValue,
                                value: [
                                    filterMap.get(inputRangeInfo.keyValue)?.value[0] || "",
                                    selectedValue,
                                ],
                            })
                        )
                    }
                    type="number"
                    placeholder={inputRangeInfo.endPlaceholder}
                    label={inputRangeInfo.endLabel}
                    size="medium"
                    prefix={inputRangeInfo.endPrefix}
                />
            </Row>
        </Column>
    );
};
